import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HandleError, HttpErrorHandlerService } from '../http/http-error-handler.service';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { ConfigService } from '../___common/__config/config.service';

const httpOptions = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ApiConnectorService {

  apiURL;
  httpPrefix = 'https://';
  cache = {};

  // Error handling
  private handleError: HandleError;
  private handleLoginError: HandleError;

  APIs_CONFIG;
  WEBAPP_LOGIN_BASE_URL;

  WEBAPP_POST_URL = this.configService.getApiUrlRefactor('domainWebapp')+'/api-webapp/post/create.php';
  

  constructor(private http: HttpClient,httpErrorHandler: HttpErrorHandlerService,private guiFlow: GuiFlowService,private configService: ConfigService) {
    this.handleError = httpErrorHandler.createHandleError('ApiSessionService');
    this.handleLoginError = httpErrorHandler.createHandleError('AuthService');
  }

  getApiUrl(label){
    switch(label){
      case 'login-webapp':
      case 'cookiesAppLogin':
        return this.WEBAPP_LOGIN_BASE_URL;
      case 'webapp':
      default:
        return this.configService.getBaseUrl();;
    }
  }

  sendRequestToServer(url,label,force){
    if (!this.cache[label] || force) {
      this.cache[label] = this.http.get(`${url}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      );
    }
  }

  selectApi(queryId){
    switch(queryId){

      case 'getThisClientAppsOld':
        return 'dashboard-connector';
      case 'clientDetails':
        return 'api-dashboard';

      ///// NEW 2025
      case 'getClientDetails':
      case 'check-token':
        return 'api-webapp';
      default:
        this.guiFlow.openSimpleSnackBar('No api confifured in typescript.',null,null);
        return 'apiDev';
    }
  }

  selectApiConfig(){

  }

  // REFACTOR 2025
  newApiGetRequest(queryName: string, queryParam1: string,queryParam2: string,queryParam3: string, queryParam4: string){
    
    let config = this.getQueryIdConfig(queryName);
    let queryParam = '?queryId=' + queryName;
    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;

    // READY URL
    this.apiURL = config['requestUrl'] + queryParam;
    
    return this.http.get<any>(this.apiURL)
    .pipe(map(data => this.getResponse(data)));
  }

  voyjaleasApiRequest(queryName: string, queryParam1: string,queryParam2: string,queryParam3: string, queryParam4: string,NewElement:any){
    
    let queryParam;
    let phpFileName = '';
    let config = this.getQueryIdConfig(queryName);
    this.apiURL  = config['requestUrl'];
    phpFileName = config['fileName'];

    if(config['operation'] == 'post'){
      const queryParam = '?table=' + queryParam1;
      this.apiURL = this.WEBAPP_POST_URL + queryParam;
      
      return this.http.post<any>(this.apiURL, NewElement, httpOptions)
      .pipe(
        catchError(this.handleError('addingNewElement', {
          KO: 'KO',
          message: 'Error on create',
          code: '19'
        }))
      );
    }

    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;

    if(config['operation'] == 'get'){

      queryParam = '?queryId=' + queryName;
      this.apiURL = this.WEBAPP_POST_URL + queryParam;
      return this.http.get<any>(this.apiURL)
      .pipe(map(data => this.getResponse(data)));
    }

    if(config['operation'] == 'put'){
      !NewElement? NewElement = { test: null} : null;
      return this.http.put<any>(this.apiURL, NewElement, httpOptions)
      .pipe(
        catchError(this.handleError('updatingNewElement', NewElement))
      );
    }
  }

  getResponse(data){
    return data; 
  }

  getDomain(queryId){
    
    switch(queryId){
      case 'checkOption':
        return 'voyjaleasdash.ipnetcostarica.com';
      default:
        return 'voyjaleas.com';
    }
  }

  getApiAssigned(queryId){
    
    switch(queryId){
      default:
        this.guiFlow.openSimpleSnackBar('No api configured in typescript.',null,null);
        return 'default';
    }
  }

  getQueryIdConfig(queryId){
    let config = {};
    switch(queryId){
      //FINAL 2025
      case 'getThisClientApps':
        config['requestUrl'] = this.configService.getBaseUrl();
        return config;

      // REFACTOR 2025
      case 'clientChecklists':
      case 'getClientTools':
      case 'getStepsForChecklistItem':
      case 'get':
      case 'check-token':
        config['requestUrl'] = this.configService.getBaseUrl();;
        config['fileName'] = 'webappApi.php';
        return config;
      // NEW 2025
      case 'getClientDetails':
      case 'getThisClientAppsOld':
        config['fileName'] = 'apiWebapp.php';
        config['domain'] = 'appvoyjaleas.ipnetcostarica.com';
        config['apiUrl'] = 'api-webapp';
        config['operation'] = 'get';
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' + config['apiUrl'] + '/' +config['operation']+'/';
        return config;
      // GETS
      case 'getInteractionXclient':
        config['fileName'] = 'myapi.php';
        config['domain'] = 'voyjaleasdash.ipnetcostarica.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'get';
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';
        return config;
      case 'getClientOmnibusContract':
        config['fileName'] = 'myapi.php';
        config['domain'] = 'dashboard.voyjaleas.com';
        config['apiUrl'] = 'api';
        config['operation'] = 'get';
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/dynamic/query/';
        return config;
      /////
      case 'getUserHealthForm':
        config['fileName'] = 'myapi.php';
        config['domain'] = 'voyjaleas.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'get';
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/dynamic/query/';
        return config;
      case 'post':
        config['fileName'] = 'create.php';
        config['domain'] = 'voyjaleas.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'post';
        config['requestUrl'] = config['domain'] + '/backend/' +  config['apiUrl'] + '/'+ config['operation']+'/dynamic/';
        return config;
      case 'getInteractionXclientOld':
        config['fileName'] = 'myapi.php';
        config['domain'] = 'voyjaleas.com';
        config['apiUrl'] = 'api-dashboard';
        config['operation'] = 'get';
        config['requestUrl'] = this.httpPrefix + config['domain'] + '/'+  config['apiUrl'] + '/'+ config['operation']+'/dynamic/query/';
        return config;
      default:
        this.guiFlow.openSimpleSnackBar('No endpoint confifured in typescript.',null,null);
        return config = {
          // TODO
        }
    }
  }

  saveNewPass(loginObj: string) {
    let config = {};
    let newPassword = {
      email: loginObj['username'],
      password: loginObj['password'],
      token: loginObj['token']
    };
    config['fileName'] = 'webappUpdate.php';
    config['domain'] = this.configService.getApiUrlRefactor("domainWebapp");
    config['apiUrl'] = 'api-webapp';
    config['operation'] = 'put';
    config['requestUrl'] = config['domain'] + '/' + config['apiUrl'] + '/'+ config['operation'] +'/'+ config['fileName']+'?queryId=createNewPassword';
    return this.http.put<any>(config['requestUrl'], newPassword, httpOptions)
    .pipe(
      catchError(this.handleError('updatingNewElement', newPassword))
    );
  }

  generateNewLink(loginObj){

    let config = {};
    let tryLog = {
      username: loginObj['username'],
    };
    config['fileName'] = 'generatePassLink.php';
    config['domain'] = this.configService.getApiUrlRefactor("domainWebapp");
    config['apiUrl'] = 'api-webapp';
    config['operation'] = 'post';
    config['requestUrl'] = config['domain'] + '/' + config['apiUrl'] + '/'+ config['operation'] +'/'+ config['fileName'];
    return this.http.post<any>(config['requestUrl'], tryLog, httpOptions)
    .pipe(
      catchError(this.handleError('updatingNewElement', tryLog))
    );
  }

  newLogin(loginObj) {
    let config = {};
    let tryLog = {
      username: loginObj['username'],
      password: loginObj['password']
    };
    config['fileName'] = 'webappLogin.php';
    config['domain'] = this.configService.getApiUrlRefactor("domainWebapp");
    config['apiUrl'] = 'api-webapp';
    config['operation'] = 'post';
    config['requestUrl'] = config['domain'] + '/' + config['apiUrl'] + '/'+ config['operation'] +'/'+ config['fileName'];
    return this.http.post<any>(config['requestUrl'], tryLog, httpOptions)
    .pipe(
      catchError(this.handleLoginError('login', { tryLog }))
    );
  }

  checkPassToken(){

  }

  login( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string): Observable<any> {
    let apiURL;
    let queryParams = '?queryId='+queryId;
    queryParam1 ? queryParams = queryParams + '&queryParam1=' + queryParam1 : null;
    queryParam2 ? queryParams = queryParams + '&queryParam2=' + queryParam2 : null;
    queryParam3 ? queryParams = queryParams + '&queryParam3=' + queryParam3 : null;
    apiURL = this.getApiUrl(queryId) + queryParams;
    let force = true;

    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

  simpleQueryId( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string,queryParam4: string,queryParam5: string): Observable<any> {
    let phpFileName = '';
    let apiURL  = this.configService.getApiUrlRefactor('domainWebapp') + '/' + this.selectApi(queryId)  + '/get/dynamic/query/';
    let queryParam = '?queryId='+queryId;
    queryParam1 !== null? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 !== null? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 !== null? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 !== null? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    queryParam5 !== null? queryParam = queryParam + '&queryParam5=' + queryParam5 : queryParam = queryParam;

    phpFileName = 'myapi.php';
    apiURL = apiURL + phpFileName + queryParam;
    let force = true;
    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

  // TO DELETE - ONLY FOR JOSEP DEOM
  simpleQueryId2( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string,queryParam4: string,queryParam5: string): Observable<any> {
    let phpFileName = '';
    let apiURL  = this.configService.getApiUrlRefactor('domainWebapp') + '/' + this.selectApi(queryId)  + '/get/';
    let queryParam = '?queryId='+queryId;
    queryParam1 !== null? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 !== null? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 !== null? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 !== null? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    queryParam5 !== null? queryParam = queryParam + '&queryParam5=' + queryParam5 : queryParam = queryParam;

    phpFileName = 'myapi.php';
    apiURL = apiURL + phpFileName + queryParam;
    let force = true;
    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

    // Usage
  //const data = await this.getXhr(url).toPromise();
  getXhr(url){
    return this.http.get(url)
    //return this.http.get(url, { params }); // Returns an Observable
  }


  getQueryResult(queryId: string, params?: {
    queryParam1?: string,
    queryParam2?: string,
    queryParam3?: string,
    queryParam4?: string
  }) {

    let baseUrl = this.configService.getApiUrlRefactor('appGet');
    let httpParams = new HttpParams().set('queryId', queryId);

    if (params?.queryParam1) httpParams = httpParams.set('queryParam1', params.queryParam1);
    if (params?.queryParam2) httpParams = httpParams.set('queryParam2', params.queryParam2);
    if (params?.queryParam3) httpParams = httpParams.set('queryParam3', params.queryParam3);
    if (params?.queryParam4) httpParams = httpParams.set('queryParam4', params.queryParam4);

    return this.http.get(baseUrl, { params: httpParams, withCredentials: true });
  }
    
}